/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react';
import { DIV } from 'src/components/CustomStyledComponents';
import FooterButton from 'src/components/FooterBtn/FooterButton';
import HeaderPage from 'src/components/header/HeaderPage';
import NavbarHeader from 'src/components/header/NavbarHeader';
import LoadingWrapper from 'src/components/Loading/LoadingWrapper';
import withCotizacion from 'src/HOC/withCotizacion';
import useLoading from 'src/hooks/useLoading';
import usePageValidation from 'src/hooks/usePageValidation';

const ErrorPageContainer = ({ cotizacion }) => {
  const { values } = useLoading();

  const [data, setData] = useState({
    titulo: 'Error',
    message: 'Estimado cliente',
    img: 'https://www.webcolorsonline.com/images/error.png',
    showFooterButton: true,
    hrefButton: 'https://www.google.com/',
  });

  const { execEvent, isLoadingCallbacks } = usePageValidation('paginaError');

  const init = useCallback(async () => {
    await execEvent('initCallback', { setData, data });
  }, [isLoadingCallbacks]);

  useEffect(() => {
    if (isLoadingCallbacks) return;

    init();

    return () => {
      execEvent('outCallback');
    };
  }, [isLoadingCallbacks]);

  const onClickContinuar = (event) => {
    window.location.href = `${data?.hrefButton}${cotizacion.idCotizacion}`;
  };

  return (
    <LoadingWrapper {...values}>
      <DIV
        stylePath="errorPage.globalStyles"
        className="container-fluid container-page"
      >
        <NavbarHeader showBack={false}  />

        <HeaderPage progreso={0} />

        <div className="row justify-content-center">
          <div className="col-11 col-md-6 mt-3">
            <h4 className="titulo font-weight-bold">Error</h4>
            <p className="descripcion">
              Estimado cliente ha ocurrido un problema
            </p>
            <hr />
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-11 col-md-8 col-lg-6 mt-4">
            <div className="text-center">
              <img className="img-fluid w-25" src={data?.img} alt="" />
              <h4>{data?.titulo}</h4>
            </div>
            <div className="mt-3">{data?.message}</div>
          </div>
        </div>

        {data?.showFooterButton && (
          <FooterButton
            className="footer_button__continuar"
            classNameContainer="footer_container__continuar"
            label="Continuar"
            type="button"
            onClick={onClickContinuar}
          />
        )}
      </DIV>
    </LoadingWrapper>
  );
};

const ErrorPage = withCotizacion(ErrorPageContainer);

export default ErrorPage;
